import React, { useEffect, useState } from 'react'

import {
  KeyboardArrowDown as KeyboardArrowDownIcon,
  KeyboardArrowUp as KeyboardArrowUpIcon
} from '@mui/icons-material'
import { Collapse, IconButton } from '@mui/material'
import { TableCellStyled, TableRowStyled, TableStyled } from 'components'
import { If, Then } from 'react-if'
import { Item } from 'services/NGT/EffectiveConsolidation'
import { FORMAT, COLORS } from 'utils'

interface ICollapsibleTable {
  row: Item
  isGeneratePDF: boolean
}

export const CollapsibleTable: React.FC<ICollapsibleTable> = ({
  row,
  isGeneratePDF
}) => {
  const [open, setOpen] = useState(isGeneratePDF)

  useEffect(() => {
    if (isGeneratePDF) setOpen(true)
  }, [isGeneratePDF])

  return (
    <>
      <TableRowStyled>
        <TableCellStyled>
          {row?.unidadeGestoraInfo.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStyled>
        <TableCellStyled minwidth="200px">
          {row?.nmGrupoConsolidacao}
        </TableCellStyled>

        <React.Fragment>
          <TableCellStyled align="center">
            {row?.informaoAnoMeses?.length
              ? row?.informaoAnoMeses[12]?.info?.horaNormal?.toLocaleString(
                'pt-br'
              )
              : 0}
          </TableCellStyled>
          <TableCellStyled align="center">
            {row?.informaoAnoMeses?.length
              ? row?.informaoAnoMeses[12]?.info?.horaExtra?.toLocaleString(
                'pt-br'
              )
              : 0}
          </TableCellStyled>
        </React.Fragment>

        {row?.informaoAnoMeses.map(({ info, mes }, index) => (
          <If condition={index !== 12}>
            <Then>
              <React.Fragment key={mes}>
                <TableCellStyled align="center">
                  {info?.horaNormal?.toLocaleString(
                    'pt-br'
                  )}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {info?.horaExtra?.toLocaleString(
                    'pt-br'
                  )}
                </TableCellStyled>
              </React.Fragment>
            </Then>
          </If>
        ))}
      </TableRowStyled>

      {/*  INICIO TABLE COLLAPSED */}
      <TableRowStyled style={{ display: !open && 'none' }}>
        <TableCellStyled style={{ padding: 0 }} colSpan={26}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <TableStyled>
              <TableRowStyled backgroundColor={COLORS.tableColor}>
                <TableCellStyled colSpan={1} />
                <TableCellStyled colSpan={2} align="center">
                  Dez
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Jan
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Fev
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Mar
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Abr
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Mai
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Jun
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Jul
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Ago
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Set
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Out
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Nov
                </TableCellStyled>
                <TableCellStyled colSpan={2} align="center">
                  Dez
                </TableCellStyled>
              </TableRowStyled>

              <TableRowStyled backgroundColor={COLORS.tableColor}>
                <TableCellStyled colSpan={1} />
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
                <TableCellStyled align="center">HNT</TableCellStyled>
                <TableCellStyled align="center">HE</TableCellStyled>
              </TableRowStyled>

              {row?.unidadeGestoraInfo.map((collapseRow, index) => (
                <TableRowStyled key={index}>
                  <TableCellStyled colSpan={1}>
                    {collapseRow?.nmUnidadeGestora}
                  </TableCellStyled>

                  <React.Fragment>
                    <TableCellStyled>
                      {collapseRow?.informaoAnoMeses?.length
                        ? collapseRow?.informaoAnoMeses[12].info?.horaNormal?.toLocaleString(
                          'pt-br'
                        )
                        : 0}
                    </TableCellStyled>
                    <TableCellStyled>
                      {collapseRow?.informaoAnoMeses?.length
                        ? collapseRow?.informaoAnoMeses[12].info?.horaExtra?.toLocaleString(
                          'pt-br'
                        )
                        : 0}
                    </TableCellStyled>
                  </React.Fragment>

                  {collapseRow?.informaoAnoMeses.map(({ info }, index) => (
                    <If condition={index !== 12}>
                      <Then>
                        <React.Fragment key={index}>
                          <TableCellStyled>{info?.horaNormal?.toLocaleString(
                            'pt-br'
                          )}
                          </TableCellStyled>
                          <TableCellStyled>{info?.horaExtra?.toLocaleString(
                            'pt-br'
                          )}
                          </TableCellStyled>
                        </React.Fragment>
                      </Then>
                    </If>
                  ))}
                </TableRowStyled>
              ))}
            </TableStyled>
          </Collapse>
        </TableCellStyled>
      </TableRowStyled>
    </>
  )
}
